import { CompanySettings } from "src/app/services/response-models/companies.response.model";

export class SetCompanySettings {
    static readonly type = "[APP] Set Company Settings";

    constructor(public payload: CompanySettings) {}
}
